var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseChart',{attrs:{"options":_vm.mergedOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }